<template>
  <v-container style="padding: 0;" class="auth-container" fluid>
    <slot></slot>
  </v-container>
</template>

<script>
export default {
  computed: {
    is_login() {
      return this.$store.getters.is_login
    },
    loading() {
      return this.$store.getters.loading
    },
    toast() {
      return this.$store.getters.toast
    },
    modal() {
      return this.$store.getters.modal
    },
    activeMenu() {
      return this.$store.getters.activeMenu
    }
  }
}
</script>

<style></style>
